import { getBarColor } from './getBarColor'
import { getLayerHeight } from './getLayerHeight'
import { getLayerSpacing } from './getLayerSpacing'

export { getBarColor, getLayerHeight, getLayerSpacing }



// WEBPACK FOOTER //
// ./src/node_modules/components/functions/index.js